import {sortBy} from 'lodash';
import {useMemo} from 'react';
import {useMyUserId} from '../sessionHooks';
import {useFilteredParticipants} from './useFilteredParticipants';

export function useMutualFavorites(eventId, {filter, sortBy: sortFunction, count}) {
    const participants = useFilteredParticipants(eventId, {mutualFavorites: true})[0] ?? [],
        selfId = useMyUserId();

    return useMemo(() => {
        let result = participants.filter(user => (user.user_id ?? user.id) != selfId);

        if (filter) result = result.filter(filter);
        if (sortFunction) result = sortBy(result, sortFunction);
        if (count) result = result.slice(0, count);

        return result;
    }, [selfId, participants, filter, sortFunction, JSON.stringify(count)]);
}
